import styled from 'styled-components';

export const StyledLiveCourseVideoPage = styled.div`
  /* Code Here */
`;